<template>
  <v-container :class="small == null ? 'container' : 'container small'" fluid row>
    <v-layout>
      <v-flex
        v-for="phaseName in this.phases"
        px-3
        py-2
        :xs9="phaseName === phase"
        :key="phaseName">
        <h2 v-if="phaseName === phase">
          <span v-if="canChangePhase && small == null">
            <v-btn icon small dark
              v-if="phase !== phases[0]"
              @click="openConfirmDialog(-1)">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            {{ $vuetify.t('$vuetify.TopicPhase.' + phase) }}
            <v-btn icon small dark
              v-if="phase !== phases[phases.length - 1]"
              @click="openConfirmDialog(+1)">
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </span>
          <span v-else>{{ $vuetify.t('$vuetify.TopicPhase.' + phase) }}</span>
        </h2>
        <span v-else>&nbsp;</span>
      </v-flex>
    </v-layout>
    <v-dialog v-model="confirmPhaseUpdateDialog" width="500">
      <v-card>
        <v-card-text>
          {{ $vuetify.t('$vuetify.TopicPhase.confirmDialogMessage') }}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="update()" color="primary">
            {{ $vuetify.t('$vuetify.Form.ok') }}
          </v-btn>
          <v-btn @click="confirmPhaseUpdateDialog = false">
            {{ $vuetify.t('$vuetify.Form.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'

export default {
  computed: {
    phase: function () { return this.topic && this.topic.phase },
    canChangePhase: function () {
      return this.$hasPermissionInIdeaSpace(this.$permissions.topic.items.changeTopicPhase, this.topic.idea_space)
    },
    phaseOptions: function () {
      return this.phases.map(p => ({
        text: this.$vuetify.t('$vuetify.TopicPhase.' + p),
        value: p
      }))
    }
  },
  data: function () {
    return {
      isLoading: false,
      phases: this.$store.getters.phases,
      confirmPhaseUpdateDialog: false,
      updateMethod: null
    }
  },
  methods: {
    openConfirmDialog (updateMethod) {
      this.updateMethod = updateMethod
      this.confirmPhaseUpdateDialog = true
    },
    async update () {
      const newIndex = (this.phases.indexOf(this.phase) + this.updateMethod) % this.phases.length
      const newPhase = this.phases[newIndex]
      const path = this.$route.path

      if (this.phase === 'edit_topics' && newPhase !== 'feasibility') {
        const ideas = (await api.topic.getIdeas(this.topic.id)).data
        for (let idea of ideas) {
          let feasibility = {
            school_id: this.$store.getters.selected_school,
            created_by: this.$store.getters.user.profile.id,
            idea: idea.id,
            val: true,
            reason: 'automatic approve'
          }
          const result = await api.idea.updateOrCreateFeasibility(feasibility)
          if (result.status >= 400) {
            alert('There was error while update the ideas feasibility')
            return
          }
        }
      }

      this.confirmPhaseUpdateDialog = false
      api.topic.setPhase(this.topic.id, newPhase)
        .then(() => {
          this.$router.push({ name: 'Redirect', params: { path: path } })
        })
    }
  },
  props: ['topic', 'small']
}
</script>

<style scoped lang="scss">
.container {
  padding: 0;
}

.small {
  flex: 1 0 0px;
  overflow:hidden;

  .flex {
    font-size: 0.7em;
  }
}

.flex {
  background-color: var(--v-secondary-base);
  text-transform: uppercase;
  color: white;
  font-size: 0.8em;
}

.v-btn {
  margin: 0;
}

.flex:nth-child(1) {
  background-color: #8c9eff;
}

.flex:nth-child(2) {
  background-color: #536dfe;
}

.flex:nth-child(3) {
  background-color: #304ffe;
}

.flex:nth-child(4) {
  background-color: #1a237e;
}
</style>
